import React from "react"
import {ConnectSpinner} from "../../../spinner"
import {LoadingCoverContainer} from "./components"

interface Cotton22LoadingCoverProps {
    testId: string
    ariaValueText: string
    itemsRequestPending: boolean
    breadcrumbsEnabled: boolean
    isMerchandisedUrl: boolean
}

export const Cotton22LoadingCover = ({
    testId,
    ariaValueText,
    itemsRequestPending,
    breadcrumbsEnabled,
    isMerchandisedUrl,
}: Cotton22LoadingCoverProps) => {
    if (!itemsRequestPending) return null

    return (
        <LoadingCoverContainer
            data-testid="plp-loading-cover"
            breadcrumbsEnabled={breadcrumbsEnabled}
            isMerchandisedUrl={isMerchandisedUrl}
        >
            <ConnectSpinner testid={testId} ariaValueText={ariaValueText} />
        </LoadingCoverContainer>
    )
}

export default Cotton22LoadingCover
